import { Component, OnInit, OnDestroy } from '@angular/core';
import { LanguageService } from '../../shared/services/language.service';
import { TranslateService } from '@ngx-translate/core';

import { Router, ActivatedRoute } from '@angular/router';
import { AccountService } from '../../shared/services/account.service';
import { ContactService } from '../../shared/services/contact.service';
import { RegisterSettingService } from '../../shared/services/register-setting.service';
declare var $: any;
import {isBrowser} from '../../shared/thirdparty/isBrowser'

@Component({
  selector: 'app-echange-formation',
  templateUrl: './echange-formation.component.html',
  styleUrls: ['./echange-formation.component.scss']
})
export class EchangeFormationComponent implements OnInit, OnDestroy {

  public contactFormHiddenInputs = []
  public prefillFields = []

  public certifications = [
      {
          src : "assets/certifications/logo-evalim",
          width : "110px",
          alt: "Logo of the Evalim certification",
          title:"Evalim",
      },
      {
          src : "assets/certifications/logo-prp",
          width : "85px",
          alt: "Logo of the PRP certification",
          title:"PRP",
      },
      {
          src : "assets/certifications/logo-dreet",
          width : "145px",
          alt: "Logo of the Dreets certification",
          title:"Dreets",
      },
      {
          src : "assets/certifications/logo-cqp",
          width : "105px",
          alt: "Logo of the CQP certification",
          title:"CQP",
      },
      {
          src : "assets/certifications/logo-cse",
          width : "105px",
          alt: "Logo of the CSE certification",
          title:"CSE",
      },
      {
          src : "assets/certifications/logo-qualiopi-certificat-rvb",
          width : "200px",
          alt: "Logo of the Qualiopi certification",
          title:"Qualiopi",
      }
  ]

  constructor(
    public language : LanguageService,
    public translate: TranslateService,
    public contactService:ContactService,
    public router : Router,
    public activatedRoute: ActivatedRoute,
    private accountService : AccountService
  ) { }

  ngOnInit() {
      if(this.activatedRoute.snapshot.paramMap['params']['action'] && this.activatedRoute.snapshot.paramMap['params']['action']=='o'){
          this.showModalContact()
      }
      if(this.accountService.isLogged()){
          this.contactFormHiddenInputs = ['origin']
      }
      // console.log('state', this.router)
      // console.log(this.router.getCurrentNavigation())
      if(isBrowser()){
          if(window.history.state && window.history.state['prefillContact']){
              this.prefillFields = [{id: "message", value: window.history.state['prefillContact']}]
          }
      }
  }

  ngOnDestroy(){
      if(isBrowser()){
          $('.modal-backdrop').remove()
      }
  }


  // Contact modal -----------------------------------------
  showModalContact(){
      if(isBrowser()) $('#contact-modal').modal('show')
  }
  hideModalContact(){
      if(isBrowser()) $('#contact-modal').modal('hide')
  }
  modalIsOpen(){
      return isBrowser() ? $('#contact-modal').is(':visible') : false
  }
  openChat(){
      if(isBrowser() && window && window['$chatwoot']){
          window['$chatwoot'].toggle("open");
      }
  }

}
